<template>
  <div>
    <div class="author-name">
      {{ propsData.user ? propsData.user.full_name : "" }}
      <small class="chat-date">{{
        $getJalaliDateTime(propsData.created_at)
      }}</small>
    </div>
    <div
      :class="isMyComment(propsData) ? 'chat-message active' : 'chat-message'"
    >
      {{ propsData.comment }}
    </div>
    <div class="child">
      <tree-node
        v-for="comment in propsData.replies"
        :key="comment.id"
        :props-data="comment"
      />
    </div>
  </div>
</template>

<script>
import TreeNode from "./TreeNode.vue";

export default {
  name: "tree-node",
  components: { TreeNode },
  props: { propsData: {} },
  methods: {
    isMyComment(comment) {
      return comment.current == true;
    },
  },
};
</script>

<style lang="scss" scoped>
.child {
  margin-right: 50px;
}
</style>
